import API from '../interceptors/Api';
import { LINK_QUEUED_STATUS } from '../assets/constants/Link';

export const getLinks = (params) => API.get('/links', {
  params,
});

export const enableLinkStatus = (id, status) => API.patch(`/links/${id}/status/${status}`);

export const refreshLink = (id, params = {}) => {
  const {
    dateTo,
    dateFrom,
    ...rest
  } = params;
  return API.post(`/links/${id}`, rest, {
    params: {
      dateFrom,
      dateTo,
    },
  });
};

export const createLink = (data) => API.post('/links', data);

export const updateLink = (id, data) => API.put(`/links/${id}`, data);

export const generateManualPreLogin = (id, data) => API.put(`/links/${id}/manual-pre-login`, data);

export const continueLinkCreation = ({
  linkId,
  authenticationStepId,
  ...data
}) => API.post(`/links/${linkId}/steps/${authenticationStepId}`, data);

export const getLinkDetail = (id, params = {}) => API.get(`/links/${id}`, { params });

export const deleteLink = (id) => API.delete(`/links/${id}`);

export const getLinksProcessing = () => API.get('/links/processing');

export const getAllLinks = (params = {}) => API.get('/links', {
  params: {
    page: 0,
    size: 500,
    showRelations: false,
    ...params,
  },
});

export const getAllLinksWithRelations = () => API.get('/links', {
  params: {
    page: 0,
    size: 500,
    showRelations: true,
  },
});

export const checkLinkQueuedStatus = async (linkId, retries = 60) => {
  const link = await API.get(`/links/${linkId}/async-status`);
  const queueEndedStatus = [LINK_QUEUED_STATUS.READY, LINK_QUEUED_STATUS.FAILED];

  if (queueEndedStatus.includes(link?.stepStatus) || retries === 0) {
    return {
      link,
      retries,
    };
  }

  // eslint-disable-next-line no-promise-executor-return
  await new Promise((r) => setTimeout(r, 3500));
  return checkLinkQueuedStatus(linkId, retries - 1);
};

export const getInfoCount = () => API.get('/links/info/count');

export const linkSyncAssets = (linkId, data = {}) => API.post(`/links/sync/assets/${linkId}`, data);

export const linkSyncInfo = (linkId, config) => API.get(`/accounts/sync-status?linkId=${linkId}`, config);

export const getLinksFailedSyncs = () => API.get('/links/failed-syncs');

export const linksFailedSyncs = () => API.post('/links/failed-syncs');

export const getLinkMetadata = (id) => API.get(`/links/${id}/metadata`);

export const regenerateTrxSummary = (id, data) => API.post(`/links/${id}/transaction-summary-event`, data);

export const categorizeTrx = (id, data) => API.post(`/links/${id}/categorization-event`, data);
